export default __webpack_public_path__ + "static/media/redbook3.cde2b392.jpg";